module.exports = __webpack_public_path__ + "static/media/BriFlix.5ea622bd.png";